// 文章中心
import request from "@/utils/request.js";
// let path = "/api";
const ArticleCenter = {
  /**
   * 登录获取token
   * @param name @type String 文章名
   * @param caseType @type String 类型
   * @param startTime @type String 用户名
   * @param endTime @type String 密码
   * @param articleType @type String 类型 方案数据" 1 新闻数据" 2 案例数据" 3
   * @param page @type String 页码
   * @param pageSize @type String 条数
   */
  queryAcList: async (data) => {
    return await request("post", "/article-center/list-data", data);
  },

  /**
   * 添加/修改用户
   * @param id @type String id  再新增的时候直接不传这个参数 在修改的时候再传
   * @param name @type String 用户名
   * @param introduction @type String
   * @param startStatus @type Number
   * @param imgUrl @type String 图片地址
   * @param innerText @type String 内容
   * @param type @type String 类型 方案数据" 1 新闻数据" 2 案例数据" 3
   * @param delStatus @type String   未删除为0   删除为1
   * @param createTime  @type String   创建时间
   * @param betterStatus  @type String   首页优秀方案 1=启用，2=禁用
   */
  addOrUpDate: async (data) => {
    return await request("post", "/article-center/add", data);
  },
  /**
   * 登录获取token
   * @param id @type String 文章id
   */
  delAcList: async (data) => {
    return await request("get", "/article-center/logic-del-article", data);
  },

  /**
   * 文章详情-查询
   * @param articleCenterId @type String 文章ID
   */
  getDetail: async (params) => {
    return await request("get", "/article-center/detail", params);
  },
};
export default ArticleCenter;



// WEBPACK FOOTER //
// ./src/api/articleCenter.js